import styled, { keyframes } from 'styled-components';

const rotatePhone = keyframes`
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(-90deg);
  }

  100% {
    transform: rotate(-90deg);
  }
`;

export const StyledRotateDevicePrompt = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.size.dynamic0150};

  color: #fff;
  background-color: #000;
  text-align: center;
  pointer-events: auto;
`;

export const StyledPhone = styled.div`
  width: 100px;
  height: 50px;

  border: 3px solid currentColor;
  border-radius: 10px;

  animation: ${rotatePhone} 1.5s ease-in-out infinite alternate;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: rotate(-90deg);
  }
`;

export const StyledMessage = styled.div`
  margin-top: 40px;
`;
